export const HORMONAL_HEALTH_EN = 'Hormonal Health';
export const HORMONAL_HEALTH_FR = 'Santé hormonale';

export const isHormonalHealthCategory = categoryName =>
  [HORMONAL_HEALTH_EN, HORMONAL_HEALTH_FR]
    .map(name => name.toLocaleLowerCase())
    .includes(categoryName?.trim().toLocaleLowerCase());

export const replaceHormonalHealthCategoryName = (
  text,
  replacementCategoryName,
) =>
  [HORMONAL_HEALTH_EN, HORMONAL_HEALTH_FR].reduce(
    (result, categoryName) =>
      result?.replace(categoryName, replacementCategoryName),
    text,
  );
